import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-acd-configuration-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAcdConfigurationIconProps extends SvgIconProps {}

/**
 *
 * @param props -
 * @example
 * @returns
 */
export function CcfAcdConfigurationIcon(props: CcfAcdConfigurationIconProps) {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20">
      <path
        d="M16.9 3C16.5 1.3 14.9 0 13 0C11.1 0 9.6 1.3 9.1 3H0V5H9.1C9.5 6.7 11.1 8 13 8C14.9 8 16.4 6.7 16.9 5H20V3H16.9ZM13 6C11.9 6 11 5.1 11 4C11 2.9 11.9 2 13 2C14.1 2 15 2.9 15 4C15 5.1 14.1 6 13 6Z"
        fill="#FF9400"
      />
      <path
        d="M7 10C5.1 10 3.6 11.3 3.1 13H0V15H3.1C3.5 16.7 5.1 18 7 18C8.9 18 10.4 16.7 10.9 15H20V13H10.9C10.4 11.3 8.9 10 7 10ZM7 16C5.9 16 5 15.1 5 14C5 12.9 5.9 12 7 12C8.1 12 9 12.9 9 14C9 15.1 8.1 16 7 16Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfAcdConfigurationIcon;
